const NotFound = () => (
  <>
    <h1 className="not-found-heading">Page Not Found !!</h1>
  </>
)

export default NotFound
